module.exports = require('./helpers/bundle-url').getBundleURL('lRwKX') + "logo.c51670a8.svg";